import { MapPin, Star } from 'lucide-react'
import { H1 } from '@meiuca/ui-components'
import type { VenueDetailHeaderComponent } from '../../../types/sdui-arena-detail'
import { formatDistance } from '../../../types/arena'
import { modalitiesManager } from '@/managers/modalitiesManager'

interface VenueDetailHeaderProps {
  config: VenueDetailHeaderComponent
}

export function VenueDetailHeader({ config }: VenueDetailHeaderProps) {
  const { name, logoUrl, address, distance, rating, reviewCount, modalities } = config

  return (
    <div>
      {/* Logo + Nome */}
      <div className="flex items-center gap-4 mb-3">
        {logoUrl && (
          <div className="w-16 h-16 md:w-20 md:h-20 bg-white rounded-xl shadow-lg overflow-hidden border-2 border-border-light flex-shrink-0">
            <img
              src={logoUrl}
              alt={`${name} logo`}
              className="w-full h-full object-cover"
            />
          </div>
        )}
        <H1 className="flex-1">{name}</H1>
      </div>

      {/* Location */}
      <div className="flex items-center gap-2 text-text-secondary mb-3">
        <MapPin className="w-4 h-4" />
        <span className="text-sm">{address}</span>
        {distance !== undefined && (
          <span className="text-sm">• {formatDistance(distance)}</span>
        )}
      </div>

      {/* Rating */}
      {rating !== undefined && (
        <div className="flex items-center gap-2 mb-4">
          <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" />
          <span className="font-semibold text-text-primary">{rating.toFixed(1)}</span>
          {reviewCount !== undefined && (
            <span className="text-sm text-text-secondary">
              ({reviewCount} avaliações)
            </span>
          )}
        </div>
      )}

      {/* Modalities */}
      <div className="flex flex-wrap gap-2">
        {modalities.map((modality) => (
          <span
            key={modality}
            className="px-3 py-1 bg-brand-primary/10 text-brand-primary text-sm font-medium rounded-full"
          >
            {modalitiesManager.getModalityDescription(modality)}
          </span>
        ))}
      </div>
    </div>
  )
}
